import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Textarea } from 'components/Forms'
import { Alert } from 'ui'
import PunchService from 'services/PunchService'
import { closeModal } from 'store/actions/modals'
import { Parse, Format } from 'services/Dates'

import { t } from 'translations'

function PunchAddCommentModal({ punchCard, locale }) {
  const dispatch = useDispatch()
  const {
    flags: { isInEarly, isInLate, isOutEarly, isOutLate },
    start,
    end,
    arrival,
    leave
  } = punchCard

  // Format delays to render them
  const lateArrival = isInLate && Format(Parse(arrival), { outFormat: 'distanceRelativeStrict', relativeDate: Parse(start), locale })
  const earlyArrival = isInEarly && Format(Parse(arrival), { outFormat: 'distanceRelativeStrict', relativeDate: Parse(start), locale })
  const earlyDeparture = isOutEarly && Format(Parse(leave), { outFormat: 'distanceRelativeStrict', relativeDate: Parse(end), locale })
  const lateDeparture = isOutLate && Format(Parse(leave), { outFormat: 'distanceRelativeStrict', relativeDate: Parse(end), locale })

  const addComment = async ({ comment }) => {
    // Add the comment to the punchCard
    await PunchService.addComment(punchCard._id, comment)
    dispatch(closeModal())
  }

  // Format the message to display
  let message = ``
  if (!leave && isInLate) message = t(`employee.punch.LATEARRIVALCOMMENT`, { lateArrival })
  if (!leave && isInEarly) message = t(`employee.punch.EARLYARRIVALCOMMENT`, { earlyArrival })
  if (arrival && isOutEarly) message = t(`employee.punch.EARLYDEPARTURECOMMENT`, { earlyDeparture })
  if (arrival && isOutLate) message = t(`employee.punch.LATEDEPARTURECOMMENT`, { lateDeparture })

  return (
    <BaseModal hideButtons title={`employee.punch.PUNCH_ADD_COMMENT_MODAL`}>
      <Alert variant="warning" className="mt-2">
        {message}
      </Alert>

      <Formik onSubmit={addComment} enableReinitialize={true} initialValues={{ comment: '' }}>
        {({ isSubmitting, setFieldValue }) => {
          return (
            <Form>
              {/* {(isInLate || isOutEarly) && ( */}
              <div>
                {/* Add a new comment textarea */}
                <Textarea
                  className="mt-3"
                  module="employee.punch"
                  name="comment"
                  onChange={({ target }) => (target.value.trim() ? setFieldValue('comment', target.value) : setFieldValue('comment', target.value.trim()))}
                />
              </div>
              {/* )} */}
              {/* Submit & Close buttons */}
              <div className="mt-2">
                <Button type="submit" isSubmitting={isSubmitting} text="actions.SUBMIT" className="btn btn-primary mr-2" />
                <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
              </div>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default PunchAddCommentModal
